import Vue from 'vue'
import VueRouter from 'vue-router'
import { eventBus } from './plugins/eventBus'
import createLocalizedRoutes from './helpers/createLocalizedRoutes'
import {
  Home,
  Events,
  EventsAnnual,
  Team,
  Terms,
  Privacy,
  Conference,
  ConferenceGallery,
  ConferenceBoard,
  ConferenceRedirect
} from '@/views'

Vue.use(VueRouter)

const routes = createLocalizedRoutes(
  ['en', 'fr'],
  [
    {
      path: '',
      name: 'home',
      component: Home
    },
    {
      path: { en: 'team', fr: 'equipe' },
      name: 'team',
      component: Team
    },
    {
      path: { en: 'terms-of-use', fr: 'conditions-utilisation' },
      name: 'terms',
      component: Terms
    },
    {
      path: { en: 'privacy-policy', fr: 'politique-confidentialite' },
      name: 'privacy',
      component: Privacy
    },
    {
      path: { en: 'all-events', fr: 'tous-les-evenements' },
      name: 'events',
      component: Events
    },
    {
      path: 'conferences',
      name: 'events-annual',
      component: EventsAnnual
    },
    {
      path: 'conferences/:slug',
      name: 'conference',
      props: true,
      component: Conference
    },
    {
      path: { en: 'conferences/:slug/gallery', fr: 'conferences/:slug/galerie' },
      name: 'conference-gallery',
      props: true,
      component: ConferenceGallery
    },
    {
      path: { en: 'conferences/:slug/board', fr: 'conferences/:slug/bureau-gouverneurs' },
      name: 'conference-board',
      props: true,
      component: ConferenceBoard
    },
    {
      path: { en: 'conferences/:slug/advisory-board', fr: 'conferences/:slug/comite-aviseur' },
      name: 'conference-advisory',
      props: route => ({ ...route.params, isAdvisory: true }),
      component: ConferenceBoard
    },
    {
      path: 'conferences/:slug/*',
      name: 'conference-redirect',
      props: true,
      component: ConferenceRedirect
    }
  ],
  {
    catchAll: {
      path: '*',
      redirect: { name: 'home' }
    }
  }
)

const router = new VueRouter({
  routes,
  mode: 'history',
  base: process.env.BASE_URL,
  linkActiveClass: '-active',
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) return eventBus.emit('pop-scroll', savedPosition.y)
  }
})

export default router
